import React from "react";
import withCustomStyles from "./OrderDetailPart.style";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import LoadMorePart from "./LoadMorePart";
import { inject, observer } from "mobx-react";
import { getImage } from "../utils/UrlUtils";
import {
  dealPrice,
  isDeal,
  productActivePrice,
  productName,
  productPrice,
  isFlashDeal
} from "../utils/ProductUtils";
import ImageWithLoaderPart from "./ImageWithLoaderPart";
import { formatPackSize, formatPrice } from "../utils/FormatUtils";

@inject(["orderStore"])
@inject(["productStore"])
@observer
class OrderDetailPart extends React.Component {
  render() {
    const {
      props: { classes, product, nameCharLimit, variant }
    } = this;

    if (!product.name) {
      return <LoadMorePart />;
    }
    const onSale = isDeal(product) || isFlashDeal(product);

    return (
      <div className={classes.row}>
        <span className={classes.thumb}>
          <ImageWithLoaderPart
            width="56"
            height="56"
            alt=""
            src={getImage(product)}
            className={classes.thumbImg}
          />
        </span>
        <div className={classes.info}>
          <span className={classes.name}>
            {productName(product.name, nameCharLimit)}
          </span>
          <span className={classes.meta}>
            {formatPackSize(product.unit)}
            {variant === "found" && (
              <>
                {" · "}
                {formatPrice(
                  onSale ? dealPrice(product) : productPrice(product)
                )}{" "}
                × {product.quantity}
              </>
            )}
          </span>
        </div>
        {variant === "found" && (
          <span className={classes.lineTotal}>
            {formatPrice(product.quantity * productActivePrice(product))}
          </span>
        )}
      </div>
    );
  }
}

OrderDetailPart.propTypes = {
  product: PropTypes.object.isRequired,
  isHorizontal: PropTypes.bool,
  nameCharLimit: PropTypes.number,
  variant: PropTypes.string
};
OrderDetailPart.defaultProps = {
  isHorizontal: false,
  nameCharLimit: 80,
  variant: "found"
};

export default withRouter(withCustomStyles(OrderDetailPart));
